import { Tracker } from '@pegasus/tracker';
export var Event;
(function (Event) {
    Event["CLICK"] = "app_smartbannercta_clicked";
    Event["CLOSE"] = "app_smartbanner_closed";
    Event["VIEW"] = "app_smartbanner_view";
})(Event || (Event = {}));
export const tracker = new Tracker();
//# sourceMappingURL=track.js.map